module.exports = {
          srcSet: __webpack_public_path__ + "d79f40f9814c0492e4468316f50f1674-424.png"+" 424w",
          images:[ {path: __webpack_public_path__ + "d79f40f9814c0492e4468316f50f1674-424.png",width: 424,height: 453}],
          src: __webpack_public_path__ + "d79f40f9814c0492e4468316f50f1674-424.png",
          toString:function(){return __webpack_public_path__ + "d79f40f9814c0492e4468316f50f1674-424.png"},
          
          width: 424,
          height: 453
        }